import React, { useState } from 'react';
import shared from '../data/js/shared';

const {
  popupTitle,
  popupPlaceholder,
  confirmButton,
  cancelButton,
} = shared.userReport;

interface ReportUserPopupProps {
  userName?: string;
  onConfirm: (details: string) => void;
  onCancel: () => void;
}

const ReportUserPopup: React.FC<ReportUserPopupProps> = ({
  userName,
  onConfirm,
  onCancel,
}) => {
  const [details, setDetails] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (details.trim()) {
      onConfirm(details.trim());
    }
  };

  return (
    <div className="confirmPopup report-user-popup">
      <h3 className="heading">{popupTitle}</h3>
      {userName && (
        <p className="explain">
          Report {userName} for inappropriate behavior
        </p>
      )}
      <p className="chat-notice">This chat will be included in the report</p>
      <form onSubmit={handleSubmit}>
        <textarea
          className="report-details-input"
          placeholder={popupPlaceholder}
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          rows={4}
          autoFocus
        />
        <div className="button-row">
          <button
            type="button"
            className="cancel-button hollowButton"
            onClick={onCancel}
          >
            {cancelButton}
          </button>
          <button
            type="submit"
            className="confirm-button greenButton"
            disabled={!details.trim()}
          >
            {confirmButton}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReportUserPopup;
